module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_debernardo_sm-ad3b04b6dc9bae9bf97c0325e531e1f3.png";